
import { Link } from 'react-router-dom';

export const Footer = () => (
    <footer style={{ borderTop: '1px solid var(--border-subtle)', padding: '40px 0', marginTop: '80px', background: 'var(--bg-secondary)' }}>
        <div className="container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <div style={{ marginBottom: '16px' }}>
                <img src="/logo-with-white-text.svg" alt="Ordabell" style={{ height: '40px', width: 'auto' }} />
            </div>
            <p style={{ color: 'var(--text-tertiary)', marginBottom: '16px' }}>
                Modernizing the hospitality experience, one scan at a time.
            </p>
            <p style={{ color: 'var(--text-secondary)', marginBottom: '24px', fontSize: '0.875rem', fontWeight: 500 }}>
                Ordabell is powered by Fiescrow LLC, it is owned by Fiescrow LLC.
            </p>
            <div style={{ display: 'flex', gap: '24px', marginBottom: '24px' }}>
                <Link to="/contact" style={{ color: 'var(--text-tertiary)', textDecoration: 'none', fontSize: '0.875rem' }}>Contact Us</Link>
                <Link to="/terms" style={{ color: 'var(--text-tertiary)', textDecoration: 'none', fontSize: '0.875rem' }}>Terms of Use</Link>
                <Link to="/privacy" style={{ color: 'var(--text-tertiary)', textDecoration: 'none', fontSize: '0.875rem' }}>Privacy Policy</Link>
            </div>
            <div style={{ color: 'var(--text-tertiary)', fontSize: '0.875rem' }}>
                &copy; {new Date().getFullYear()} Fiescrow LLC. All rights reserved.
            </div>
        </div>
    </footer>
);

